export enum TemplateManagementRoute {
  // default
  HOME = '/sites/:siteId/designs/templates/:channel?',
  CREATE = '/sites/:siteId/designs/templates/create-template/:channel',
  CREATE_ONSITE = '/sites/:siteId/designs/templates/onsite/create-template',
  EDIT = '/sites/:siteId/designs/templates/:id/:language/editor/',
  EDIT_COPY = '/sites/:siteId/designs/templates/:id/:language/copy-editor/',
  EDIT_RCS = '/sites/:siteId/designs/templates/:id/:language/editor/rcs',
  EDIT_ONSITE = '/sites/:siteId/designs/templates/onsite/:id/:language/editor/',
  EDIT_UNSUBSCRIBE = '/sites/:siteId/designs/templates/unsubscribes/:id/:language/editor/',
  EDIT_EMAIL_TRACKING_UNSUBSCRIBE = '/sites/:siteId/designs/templates/email-tracking-unsubscribes/:id/:language/editor/',
  PREVIEW = '/sites/:siteId/designs/templates/:id/:language/preview',
  EDITALL = '/sites/:siteId/designs/templates/:id/editor/*',
  ARCHIVE = '/sites/:siteId/designs/templates/archive',
}
